import { render } from "./Elemento_TarifaPres.vue?vue&type=template&id=442c7fbb"
import script from "./Elemento_TarifaPres.vue?vue&type=script&lang=js"
export * from "./Elemento_TarifaPres.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__